import React, { ReactNode } from 'react'

import { Typography } from '@telavita-core/react-design-kit'

import * as S from './styles'

interface MenuDashboardItemProps {
  icon: ReactNode
  id: string | number
  title: string
  isSelected: boolean
  badge?: ReactNode
}

const MenuDashboardItem = ({ icon, id, title, badge, isSelected = false }: MenuDashboardItemProps): JSX.Element => {
  return (
    <S.Container
      isSelected={isSelected}
      id={`menu-dashboard-item-${id}`}
    >
      {icon}
      <Typography 
        color='primary'
        variant='content2'
        weight='bold'
        customClassName='MenuDashboardItem__Title'
      >
        {title}
      </Typography>
      {badge && <div className='MenuDashboardItem__Badge'>{badge}</div>}
    </S.Container>
  )
}

export default MenuDashboardItem
